/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { toRefs, ref, computed, watch, onUnmounted } from '@vue/composition-api';
import { AddRectangleIcon, MinusRectangleIcon } from 'tdesign-icons-vue';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import TableTreeStore from './tree-store.js';
import useClassName from './useClassName.js';
import { renderCell } from '../tr.js';
import { useConfig } from '../../config-provider/useConfig.js';
import { useTNodeDefault } from '../../hooks/tnode.js';
import { useGlobalIcon } from '../../hooks/useGlobalIcon.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '../utils.js';
import '@babel/runtime/helpers/typeof';
import 'lodash/isFunction';
import 'lodash/isObject';
import '../../_common/js/log/index.js';
import '../../_common/js/log/log.js';
import '../../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '../../config-provider/type.js';
import '../../_chunks/dep-115a1bd3.js';
import 'lodash/upperFirst';
import 'lodash/isString';
import 'lodash/pick';
import './useFixed.js';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/debounce';
import '../../_common/js/utils/getScrollbarWidth.js';
import '../../_common/js/utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../../utils/dom.js';
import 'vue';
import 'raf';
import '../../utils/easing.js';
import '../ellipsis.js';
import '../../utils/render-tnode.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../tooltip/index.js';
import '../../tooltip/tooltip.js';
import '../../tooltip/props.js';
import '../../popup/props.js';
import '../../popup/popup.js';
import '@popperjs/core';
import '../../utils/helper.js';
import '../../_common/js/utils/set-style.js';
import '../../popup/container.js';
import '../../config-provider/config-receiver.js';
import '../../utils/mixins.js';
import '../../utils/map-props.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../tooltip/type.js';
import '../base-table-props.js';
import './useRowspanAndColspan.js';
import '../../hooks/useLazyLoad.js';
import '../../_common/js/utils/observe.js';
import 'lodash/isEmpty';
import '../../hooks/render-tnode.js';
import '../../hooks/useConfig.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function useTreeData(props, context) {
  var _toRefs = toRefs(props),
      data = _toRefs.data,
      columns = _toRefs.columns;

  var _useConfig = useConfig("table"),
      t = _useConfig.t,
      global = _useConfig.global;

  var _useGlobalIcon = useGlobalIcon({
    AddRectangleIcon: AddRectangleIcon,
    MinusRectangleIcon: MinusRectangleIcon
  }),
      AddRectangleIcon$1 = _useGlobalIcon.AddRectangleIcon,
      MinusRectangleIcon$1 = _useGlobalIcon.MinusRectangleIcon;

  var store = ref(new TableTreeStore());
  var treeNodeCol = ref();
  var dataSource = ref([]);

  var _useClassName = useClassName(),
      tableTreeClasses = _useClassName.tableTreeClasses;

  var renderTNode = useTNodeDefault();
  var rowDataKeys = computed(function () {
    var _props$tree;

    return {
      rowKey: props.rowKey || "id",
      childrenKey: ((_props$tree = props.tree) === null || _props$tree === void 0 ? void 0 : _props$tree.childrenKey) || "children"
    };
  });
  var checkedColumn = computed(function () {
    return columns.value.find(function (col) {
      return col.colKey === "row-select";
    });
  });
  watch(checkedColumn, function (column) {
    if (!store.value || !checkedColumn.value) return;
    store.value.updateDisabledState(dataSource.value, column, rowDataKeys.value);
  });

  function getFoldIcon(h, context2) {
    var params = _objectSpread(_objectSpread({}, context2), {}, {
      type: "fold"
    });

    var defaultFoldIcon = t(global.value.treeExpandAndFoldIcon, h, params) || h(MinusRectangleIcon$1);
    return renderTNode("treeExpandAndFoldIcon", {
      defaultNode: defaultFoldIcon,
      params: params
    });
  }

  function getExpandIcon(h, context2) {
    var params = _objectSpread(_objectSpread({}, context2), {}, {
      type: "expand"
    });

    var defaultExpandIcon = t(global.value.treeExpandAndFoldIcon, h, params) || h(AddRectangleIcon$1);
    return renderTNode("treeExpandAndFoldIcon", {
      defaultNode: defaultExpandIcon,
      params: params
    });
  }

  var uniqueKeys = computed(function () {
    var _store$value, _store$value$getAllUn;

    return ((_store$value = store.value) === null || _store$value === void 0 ? void 0 : (_store$value$getAllUn = _store$value.getAllUniqueKeys(data.value, rowDataKeys.value)) === null || _store$value$getAllUn === void 0 ? void 0 : _store$value$getAllUn.join()) || "";
  });
  watch([uniqueKeys], function () {
    if (!data.value) return [];

    if (!props.tree) {
      dataSource.value = data.value;
      return;
    }

    resetData(data.value);
  }, {
    immediate: true
  });
  onUnmounted(function () {
    var _store$value$treeData;

    if (!props.tree) return;
    (_store$value$treeData = store.value.treeDataMap) === null || _store$value$treeData === void 0 ? void 0 : _store$value$treeData.clear();
    store.value = null;
  });
  watch([columns], function () {
    treeNodeCol.value = getTreeNodeColumnCol();
  }, {
    immediate: true
  });

  function resetData(data2) {
    var _props$tree2;

    var newVal = cloneDeep(data2);
    store.value.initialTreeStore(newVal, props.columns, rowDataKeys.value);

    if ((_props$tree2 = props.tree) !== null && _props$tree2 !== void 0 && _props$tree2.defaultExpandAll) {
      newVal = store.value.expandAll(newVal, rowDataKeys.value);
    }

    dataSource.value = newVal;
  }

  function getTreeNodeStyle(level) {
    var _props$tree3, _props$tree4;

    if (level === void 0) return;
    var indent = ((_props$tree3 = props.tree) === null || _props$tree3 === void 0 ? void 0 : _props$tree3.indent) === void 0 ? 24 : (_props$tree4 = props.tree) === null || _props$tree4 === void 0 ? void 0 : _props$tree4.indent;
    return indent ? {
      paddingLeft: "".concat(level * indent || 1, "px")
    } : {};
  }

  function toggleExpandData(p, trigger) {
    var _store$value2, _store$value2$treeDat, _props$onTreeExpandCh;

    dataSource.value = store.value.toggleExpandData(p, dataSource.value, rowDataKeys.value);
    var rowValue = get(p.row, rowDataKeys.value.rowKey);
    var rowState = (_store$value2 = store.value) === null || _store$value2 === void 0 ? void 0 : (_store$value2$treeDat = _store$value2.treeDataMap) === null || _store$value2$treeDat === void 0 ? void 0 : _store$value2$treeDat.get(rowValue);
    var params = {
      row: p.row,
      rowIndex: p.rowIndex,
      rowState: rowState,
      trigger: trigger
    };
    (_props$onTreeExpandCh = props.onTreeExpandChange) === null || _props$onTreeExpandCh === void 0 ? void 0 : _props$onTreeExpandCh.call(props, params);
    context.emit("tree-expand-change", params);
  }

  function getTreeNodeColumnCol() {
    var _props$tree5;

    var columns2 = props.columns;
    var treeNodeColumnIndex = ((_props$tree5 = props.tree) === null || _props$tree5 === void 0 ? void 0 : _props$tree5.treeNodeColumnIndex) || 0;

    while ((_columns2$treeNodeCol = columns2[treeNodeColumnIndex]) !== null && _columns2$treeNodeCol !== void 0 && _columns2$treeNodeCol.type || ((_columns2$treeNodeCol2 = columns2[treeNodeColumnIndex]) === null || _columns2$treeNodeCol2 === void 0 ? void 0 : _columns2$treeNodeCol2.colKey) === "__EXPAND_ROW_ICON_COLUMN__") {
      var _columns2$treeNodeCol, _columns2$treeNodeCol2;

      treeNodeColumnIndex += 1;
    }

    return columns2[treeNodeColumnIndex];
  }

  function formatTreeColumn(col) {
    if (!props.tree || col.colKey !== treeNodeCol.value.colKey) return col;

    var newCol = _objectSpread({}, treeNodeCol.value);

    newCol.cell = function (h, p) {
      var cellInfo = renderCell(_objectSpread(_objectSpread({}, p), {}, {
        col: _objectSpread({}, treeNodeCol.value)
      }), context.slots, {
        cellEmptyContent: props.cellEmptyContent
      });
      var currentState = store.value.treeDataMap.get(get(p.row, rowDataKeys.value.rowKey));
      var colStyle = getTreeNodeStyle(currentState === null || currentState === void 0 ? void 0 : currentState.level);

      var classes = _defineProperty({}, tableTreeClasses.inlineCol, !!col.ellipsis);

      var childrenNodes = get(p.row, rowDataKeys.value.childrenKey);

      if (childrenNodes && childrenNodes instanceof Array || childrenNodes === true) {
        var _store$value$treeData2;

        var iconNode = (_store$value$treeData2 = store.value.treeDataMap.get(get(p.row, rowDataKeys.value.rowKey))) !== null && _store$value$treeData2 !== void 0 && _store$value$treeData2.expanded ? getFoldIcon(h, p) : getExpandIcon(h, p);
        return h("div", {
          "class": [tableTreeClasses.col, classes],
          "style": colStyle
        }, [!!(childrenNodes.length || childrenNodes === true) && h("span", {
          "class": tableTreeClasses.icon,
          "on": {
            "click": function click() {
              return toggleExpandData(p, "expand-fold-icon");
            }
          }
        }, [iconNode]), cellInfo]);
      }

      return h("div", {
        "style": colStyle,
        "class": classes
      }, [cellInfo]);
    };

    if (newCol.ellipsis === true) {
      newCol.ellipsis = function (h, p) {
        return renderCell(_objectSpread(_objectSpread({}, p), {}, {
          col: _objectSpread({}, treeNodeCol.value)
        }), context.slots);
      };
    }

    return newCol;
  }

  function setData(key, newRowData) {
    var rowIndex = store.value.updateData(key, newRowData, dataSource.value, rowDataKeys.value);

    var newData = _toConsumableArray(dataSource.value);

    newData[rowIndex] = newRowData;
    dataSource.value = newData;
  }

  function getData(key) {
    return store.value.getData(key);
  }

  function remove(key) {
    dataSource.value = _toConsumableArray(store.value.remove(key, dataSource.value, rowDataKeys.value));
  }

  function appendTo() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var newData = arguments.length > 1 ? arguments[1] : undefined;

    if (!key) {
      dataSource.value = store.value.appendToRoot(newData, dataSource.value, rowDataKeys.value);
      return;
    }

    dataSource.value = _toConsumableArray(store.value.appendTo(key, newData, dataSource.value, rowDataKeys.value));
  }

  function insertAfter(rowValue, newData) {
    dataSource.value = _toConsumableArray(store.value.insertAfter(rowValue, newData, dataSource.value, rowDataKeys.value));
  }

  function insertBefore(rowValue, newData) {
    dataSource.value = _toConsumableArray(store.value.insertBefore(rowValue, newData, dataSource.value, rowDataKeys.value));
  }

  function expandAll() {
    dataSource.value = _toConsumableArray(store.value.expandAll(dataSource.value, rowDataKeys.value));
  }

  function foldAll() {
    dataSource.value = _toConsumableArray(store.value.foldAll(dataSource.value, rowDataKeys.value));
  }

  function swapData(params) {
    var r = store.value.swapData(dataSource.value, params, rowDataKeys.value);

    if (r.result) {
      dataSource.value = _toConsumableArray(r.dataSource);
    } else {
      var _props$onAbnormalDrag;

      var params2 = {
        code: r.code,
        reason: r.reason
      };
      (_props$onAbnormalDrag = props.onAbnormalDragSort) === null || _props$onAbnormalDrag === void 0 ? void 0 : _props$onAbnormalDrag.call(props, params2);
      context.emit("abnormal-drag-sort", params2);
    }
  }

  function getTreeNode() {
    return store.value.getTreeNode(dataSource.value, rowDataKeys.value);
  }

  return {
    store: store,
    rowDataKeys: rowDataKeys,
    dataSource: dataSource,
    swapData: swapData,
    setData: setData,
    getData: getData,
    remove: remove,
    appendTo: appendTo,
    insertAfter: insertAfter,
    insertBefore: insertBefore,
    formatTreeColumn: formatTreeColumn,
    toggleExpandData: toggleExpandData,
    expandAll: expandAll,
    foldAll: foldAll,
    getTreeNode: getTreeNode,
    resetData: resetData
  };
}

export { useTreeData as default };
//# sourceMappingURL=useTreeData.js.map
